module.exports = __webpack_public_path__ + "img/product-showcase-video-poster.01c23e53.jpg";